export default __webpack_public_path__ + "static/media/clouds_default_mirrored.a2a8c1f0.jpg";